import React from 'react';
import PublishingMetadataField from './Field/component';

export function TitleField() {
  return (
    <PublishingMetadataField
      label="Title *"
      fieldName="title"
    />
  );
}
